export default __webpack_public_path__ + "static/media/score.7505069e.mp3";